// src/components/project-reset-button.tsx
import Button from "@/components/ui/Button";
import { useTranslation } from "react-i18next";

interface ProjectResetButtonProps {
  onReset: () => void;
  saving: boolean;
}

export function ProjectResetButton({ onReset, saving }: ProjectResetButtonProps) {
  const { t } = useTranslation();
  
  return (
    <Button
      type="button"
      variant="gray"
      onClick={onReset}
      disabled={saving}
      className="px-4 py-1.5 text-xs"
    >
      {t("actions.reset")}
    </Button>
  );
}